import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { GN } from '../../../gn';
import { base64StringToBlob } from 'blob-util';
/**
 * Generated class for the ShowonearticlePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-showonearticle',
  templateUrl: 'showonearticle.html',
})
export class ShowonearticlePage {
  loadingData: boolean = false
  artTxt = ''
  artId = ''
  artObj: any;
  classTxt = ''
  artData = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN) {
    this.artTxt = navParams.get('txt')
    this.artId = navParams.get('id')
    this.artObj = navParams.get('obj')
    this.classTxt = navParams.get('classTxt') == undefined ? '' : navParams.get('classTxt')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ShowonearticlePage');
    this.loadingData = true
    var _that = this
    _that.gn._Post('/api/getmebelviarticledata', { ident: this.gn.crypt(this.artObj.ident) }, function (_data) {
      _that.artData = _data.data
      //_that.artData = _data
      if (_data.blob[0].ACPICTURE != null && _data.blob[0].ACPICTURE != undefined) {
        var arrayBufferView = new Uint8Array(_data.blob[0].ACPICTURE.data);
        var blob1 = new Blob([arrayBufferView], { type: "image/jpeg" });
        var contentType = 'image/png';
        //var b64Data = 'iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg==';
        //var blob = base64StringToBlob(b64Data, contentType);
        //var blobUrl = URL.createObjectURL(blob);
        var blobUrl = URL.createObjectURL(blob1);
        var imgObj = <HTMLImageElement>document.getElementById('image-one-' + _that.artObj.ident)
        imgObj.src = blobUrl
      }
      //debugger

      for (var d = 0; d < _that.artData.length; d++) {
        if (_that.artData[d].descr == '' || _that.artData[d].descr == null || _that.artData[d].descr == undefined)
          // _that.artObj.descr = '/'
          _that.artObj.descr = []
        if (_that.artData[d].acSetOfItem == 505) {
          _that.artObj.price = _that.artData[d].anPrice
        } else {
          //if (_that.artData[d].acWarehouse1 == 'Салон Виницa.') {
          _that.artObj.price = _that.artData[d].anSalePrice
          //}
        }
      }
      _that.loadingData = false
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/mebelvisalon/showonearticle/showonearticle.ts